// Åpner butikkmodus på nettsiden (roykensykkelservice.no/bmod) for én kunde, slik at
// en verkstedservice kan registreres der. Brukes fra kundekortet og fra Ny kundesamhandling.
import Cookies from 'js-cookie';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const BMOD_BASE = 'https://roykensykkelservice.no/bmod';

const normalizePhone = (value) => {
  if (!value) return '';
  const digits = String(value).replace(/\D/g, '');
  if (digits.length === 10 && digits.startsWith('47')) return digits.slice(2);
  if (digits.length === 12 && digits.startsWith('0047')) return digits.slice(4);
  return digits;
};

export async function apneButikkmodus(customer, returnTo = '/') {
  const storeName = Cookies.get('selectedStore') || '';
  const storeId = Cookies.get('butikkid') || '';
  const employee = Cookies.get('selectedEmployee') || '';

  const phoneNumber = normalizePhone(customer?.phoneNumber || '');
  const firstName = customer?.firstName || '';
  const lastName = customer?.lastName || '';
  const email = customer?.email || '';
  const customerId = customer?._id || '';

  localStorage.setItem(
    'cart_customer',
    JSON.stringify({
      telefon: phoneNumber,
      fornavn: firstName,
      etternavn: lastName,
      epost: email,
      customerId,
    })
  );

  const params = new URLSearchParams({
    storeName,
    storeId,
    employee,
    returnTo,
    phoneNumber,
    firstName,
    lastName,
    email,
    customerId,
    t: String(Date.now()),
  });

  // Butikkmodus-token (R2): gir nettsiden tilgang til akkurat det butikkmodus
  // trenger, i 12 timer. Alt sendes etter «#», så verken tokenet eller
  // kundeopplysningene havner i serverlogger eller Google Analytics.
  try {
    const r = await fetch(`${API_BASE_URL}/auth/bmod-token`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ storeId, employee }),
    });
    if (r.ok) {
      const { token } = await r.json();
      if (token) params.set('token', token);
    }
  } catch (e) {
    console.error('Kunne ikke hente butikkmodus-token:', e);
  }

  window.location.href = `${BMOD_BASE}#${params.toString()}`;
}
